import * as React from 'react';

import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { withRouter } from 'react-router-dom';

import NavbarActionsMerchCtrl from './navbar-actions-merch';
import NavbarActionsGeneralCtrl from './navbar-actions-general';
import NavbarActionsReleaseCtrl from './navbar-actions-release';
import NavbarActionsUpgradeCtrl from './navbar-actions-upgrade';
import NavbarActionsOnlyNameCtrl from './navbar-actions-only-name';
import NavbarActionsOnboardingCtrl from './navbar-actions-onboarding';

type Sections =
  | 'onboarding'
  | 'general'
  | 'release'
  | 'music-video'
  | 'upgrade'
  | 'only-name'
  | 'merch';

interface NavbarActionsCtrlProps {
  location: any;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const NavbarActionsCtrl: React.FC<NavbarActionsCtrlProps> = (props) => {
  const getActiveSection = (): Sections => {
    const current = props.location.pathname;

    if (current.startsWith('/onboarding')) {
      return 'onboarding';
    }

    if (current.startsWith('/release/')) {
      return 'release';
    }

    if (current.endsWith('/upgrade-release')) {
      return 'upgrade';
    }

    if (current.startsWith('/music-video')) {
      return 'music-video';
    }

    if (     
      current.startsWith('/user/banking/new-account') ||
      current.startsWith('/user/banking/success')
    ) {
      return 'only-name';
    }

    if (
      current.startsWith('/merch') &&
      current !== '/merch/subscribe' &&
      current !== '/merch/welcome'
    ) {
      return 'merch';
    }

    return 'general';
  };

  const hideMerchButton = () => {
    const current = props.location.pathname;
    if (current === '/merch-agreement') {
      return true;
    } else {
      return false;
    }
  };

  const renderToolbar = () => {
    switch (getActiveSection()) {
      case 'onboarding':
        return <NavbarActionsOnboardingCtrl />;

      case 'general':
        return <NavbarActionsGeneralCtrl />;

      case 'release':
        return props.isMobile ? null : <NavbarActionsReleaseCtrl />;

      case 'merch':
        return props.isMobile ? null : (
          <NavbarActionsMerchCtrl hideButton={hideMerchButton()} />
        );

      case 'music-video':
        return props.isMobile ? null : <NavbarActionsReleaseCtrl />;

      case 'upgrade':
        return <NavbarActionsUpgradeCtrl />;

      case 'only-name':
        return <NavbarActionsOnlyNameCtrl />;

      default:
        return null;
    }
  };

  return renderToolbar();
};

export default withRouter(connect(mapStateToProps)(NavbarActionsCtrl));
